module.exports = __webpack_public_path__ + "img/logo-full-white.73169c5a.svg";